<template>
    <div class="column-menu-options">
        <resize
                :size-key="sizeKey"
                :min="0"
                :step="1"
                :max="12"
                hide-label
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as getters from '../../../store/modules/getters'
import Resize from '../advanced-side-menu/Resize.vue'

export default {
  components: {
    Resize
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED,
      viewmode: getters.VIEW_MODE
    }),
    sizeKey () {
      return this.viewmode === 'desktop' ? 'size' : 'sizePhone'
    }
  }
}
</script>
